import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from '@assets/i18n/en.json';
import arTranslations from '@assets/i18n/ar.json';

i18next.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  resources: {
    en: {
      translation: enTranslations
    },
    ar: {
      translation: arTranslations
    }
  },
  interpolation: {
    escapeValue: false
  }
});

export default i18next;
